import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

import * as styles from './portfolio.module.scss'
import IntroBanner from '../../components/banners/intro-banner/IntroBanner'
import RequestAccess from '../../components/request-access/RequestAccess'
import CommencementSection from '../../components/sections/commencementSection/CommencementSection'
import ReviewSection from '../../components/sections/review-section/ReviewSection'
import SplitSection from '../../components/sections/splitSection/SplitSection'
import TwinFeatureSection from '../../components/sections/twin-feature-section/TwinFeatureSection'
import SEOControl from '../../components/seoControl/seoControl'
import StoresBlock from '../../components/storesBlock/StoresBlock'
import LinkWithIcon from '../../components/ui/buttons/link-with-icon/LinkWithIcon'
import { SvgCheck } from '../../components/ui/svg-icons/SvgCheck'
import WantToKnowMore from '../../components/want-to-know-more/WantToKnowMore'
import {
  AU_CURRENCIES_TEXT,
  US_CURRENCIES_TEXT,
} from '../../constants/geolocation'
import { reviews } from '../../constants/reviews'
import ROUTES from '../../constants/routes'
import { colors } from '../../constants/style'

const TITLE = 'Bamboo Portfolio | Customise Your Crypto Portfolio'
const DESCRIPTION =
  'The Bamboo app also gives you the ability to buy Bitcoin, Ethereum, Gold and Silver instantly in a portfolio mix that is completely customisable. Buy crypto here'
const US_DESCRIPTION =
  'The Bamboo app also gives you the ability to buy Bitcoin and Ethereum instantly in a portfolio mix that is completely customisable. Buy crypto here'
const KEYWORDS =
  'bamboo, blockchain, gold, silver, precious metals, bitcoin, ethereum, digital assets, litecoin, crypto, buy, invest, invest today, micro investment, microinvestment, micro-investment, solvency protocol, proof of solvency, spare change, budget'

function PortfolioPage({ location, pageContext }) {
  const BannerImage = (
    <StaticImage
      src="../../assets/images/Portfolio.png"
      alt="Bamboo investments App"
      width={556}
      height={556}
    />
  )
  const TakeChargeImage = (
    <StaticImage
      src="../../assets/images/Portfolio_takecharge.png"
      alt="Bamboo investments App"
      width={556}
      height={720}
    />
  )

  const content = {
    firstSplitContent: {
      subTitle: 'Portfolio',
      title:
        'Easily customise a portfolio as individual as you. Plan into the future with our digital currencies.',
      text: `Our digital currencies are ${
        pageContext?.isUSRegion ? US_CURRENCIES_TEXT : AU_CURRENCIES_TEXT
      }. Select your preferred mix of our available currencies to diversify your portfolio with confidence. Invest with peace of mind to set and forget.`,
      renderedImage: (
        <StaticImage
          src="../../assets/images/Portfolio-customize.png"
          alt="Bamboo investments App"
          width={540}
        />
      ),
    },
    secondSplitContent: {
      subTitle: 'Portfolio',
      title: 'Open your account in under 90 seconds. Start investing today.',
      renderedImage: (
        <StaticImage
          src="../../assets/images/Portfolio_OpenAccount.png"
          alt="Bamboo investments App"
          width={540}
          height={540}
        />
      ),
      headingDisplay2: true,
      text: (
        <ul className={styles.list}>
          <li>
            <SvgCheck />A digital portfolio you can set and forget. You choose
            how often to track your progress.
          </li>
          <li>
            <SvgCheck />
            You can check your progress as little or as often as you like. Your
            account is accessible anywhere, anytime. Go about your lifestyle
            while your portfolio works for you in the background. Set and
            forget.
          </li>
          <li>
            <SvgCheck />
            <div className={styles.column}>
              Get access to popular cryptocurrencies like Bitcoin and Ethereum.
              <LinkWithIcon
                className={styles.link}
                to={ROUTES.BITCOIN_ETHEREUM}
              >
                Visit Bitcoin and Ethereum
              </LinkWithIcon>
            </div>
          </li>
          <li>
            <SvgCheck />
            <div className={styles.column}>
              Gold and Silver are two of the world's most time-tested precious
              metals investment options.
              <LinkWithIcon className={styles.link} to={ROUTES.GOLD_SILVER}>
                Visit Gold and Silver
              </LinkWithIcon>
            </div>
          </li>
        </ul>
      ),
    },
  }

  return (
    <>
      <SEOControl
        title={TITLE}
        description={pageContext?.isUSRegion ? US_DESCRIPTION : DESCRIPTION}
        keywords={KEYWORDS}
      />
      <IntroBanner
        title="Hand pick your investment split"
        subHeading="Customise a portfolio across Bitcoin, Ethereum, Gold and Silver Standard options."
        backgroundImage={BannerImage}
        backgroundColor={colors.citrus50}
      />
      <SplitSection {...{ ...content.firstSplitContent }} />
      <IntroBanner
        heading="Take charge of your portfolio"
        subHeading="Choose the one that works best for you."
        appendItems={<StoresBlock className={styles.storeButtons} />}
        backgroundImage={TakeChargeImage}
        fullImageHeight
        backgroundColor={colors.tealA400}
        imageBottomOnMobile
      />

      <SplitSection {...{ ...content.secondSplitContent }} />
      <ReviewSection {...reviews[6]} />
      <CommencementSection horizontal />
      <RequestAccess />
      <TwinFeatureSection
        featuresList={['Dollar Cost Averaging', 'BAM Rewards', 'Rebalance']}
      />
      <WantToKnowMore isUSRegion={pageContext?.isUSRegion} />
    </>
  )
}

export default PortfolioPage
